<template>
  <PageWrap page-title="Tipos de trabajo">
    <b-row>
     <b-col md="8" lg="6">
       <BfInput
         v-model="searchTerm"
         data-key="key"
         label="Búsqueda"
         placeholder="Buscar por nombre"
         @update="updateSearch"
       />
     </b-col>
   </b-row>

   <LoadingIndicator v-if="loadingData" />

   <BfTable
     v-else
     :data="jobs"
     :columns="tableColumns"
     border
     @row-click="tableRowClick"
           cell-class-name="tasaciones-small-cell"

   >
     <span slot="clave" slot-scope="{row}" class="tasaciones-table-marker">
       {{row.clave}}
     </span>
   </BfTable>

   <b-row class="mt-5">
     <b-col>
      <BfButton :to="{name: 'job'}" tag="router-link">Nuevo tipo de trabajo</BfButton>
     </b-col>
     <b-col class="text-right">
       <BfPagination
         v-if="jobs.length"
         :current-page="currentPage"
         :total="totalRows"
         :page-size="perPage"
         @current-change="updatePagination"
       />
     </b-col>
   </b-row>
  </PageWrap>
</template>

<script>
/* eslint-disable object-curly-newline */
import PageWrap from '@/components/PageWrap';
import LoadingIndicator from '@/components/LoadingIndicator';
import router from '@/router';
import { jobAPI } from '@/api';
import { mapState } from 'vuex';

export default {
  name: 'JobsList',

  data() {
    return {
      jobs: [],
      currentPage: 1,
      dateFrom: '',
      dateTo: '',
      loadingData: false,
      perPage: 30,
      searchTerm: '',
      totalRows: 0,
    };
  },

  created() {
    this.loadData();
  },

  methods: {
    async loadData() {
      this.loadingData = true;

      try {
        const {
          data: { data, current_page: currentPage, per_page: perPage, total },
        } = await jobAPI.getAll({
          filterStatus: this.filterStatusString,
          from: this.dateFrom !== '' ? this.dateFrom : undefined,
          page: this.currentPage,
          perPage: this.perPage,
          search: this.searchTerm,
          to: this.dateTo !== '' ? this.dateTo : undefined,
        });

        this.jobs = data;
        this.totalRows = total;
        this.perPage = Number(perPage);
        this.currentPage = currentPage;
      } finally {
        this.loadingData = false;
      }
    },

    tableRowClick({ row, column }) {
      if (column.property === 'clave') {
        const { id } = row;
        router.push({ name: 'job', params: { id: `${id}` } });
      }
    },

    updateFilter() {
      this.currentPage = 1;
      this.loadData();
    },

    updatePagination(newPage) {
      if (newPage !== this.currentPage) {
        this.currentPage = newPage;

        this.loadData();
      }
    },
    updateSearch() {
      this.loadData();
    },
  },

  computed: {
    ...mapState([
      'auth/user',
    ]),

    tableColumns() {
      return [
        {
          label: 'Clave',
          dataKey: 'clave',
          width: 150,
        },
        {
          label: 'Nombre',
          dataKey: 'nombre',
          sortable: true,
        },
      ];
    },
  },

  components: {
    LoadingIndicator,
    PageWrap,
  },
};
</script>
